/**
 * The pages of the static site that are only text (site/privacy.html): its fonts, the
 * language links remembered as on the front page, and the question about cookies.
 */
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/unbounded/600.css';

import { askConsent } from './consent';
import { rememberLanguageChoices } from './session';

rememberLanguageChoices();
askConsent();
